import { TextInput } from 'react-admin';
import { DefaultToolbarStyled } from '@/styles/overrides';
import { path } from './constants';
import useController from './useController';

const FormContent = () => {
  const { requestMVR, textInputCommonProps } = useController();
  return (
    <>
      <TextInput
        label="Compass order report"
        placeholder="(5 digits)"
        source={path('compass_order_report_id')}
        {...textInputCommonProps(5)}
      />
      <TextInput
        label="Control number"
        placeholder="(8 digits)"
        source={path('control_number')}
        {...textInputCommonProps(8)}
      />

      <DefaultToolbarStyled onSave={requestMVR} renderCancelButton={false} saveButtonLabel="Run Script" />
    </>
  );
};

export default FormContent;
